import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Hash } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, ViewIcon, TrashIcon, Menu as MenuIcons, RestoreIcon, CloseRedIcon, SuccessIcon, TimeIcon, LikeIcon, DislikeIcon } from 'assets/icons';
import { ReportService } from 'services';
import moment from 'moment';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_FORM = {
	search: '',
    status: '',
    since: '',
    until: '',
    origin: '',
	client_id: '',
	document_type_id: '',
	case: '',
	category: ''
}

class DocumentReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Usuario',
			'Email',
			'Documento',
			'Origen',
			'Fecha de Registro',
			'Intentos',
			'Estado',
			'Motivo'
		],
		form: INITIAL_FORM,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		clients: [],
		approved_count: 0,
		rejected_count: 0,
		verifications_count: 0,
		cases: [],
		categories_count: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Documentos',
				onBack: null,
				subtitle: 'Consulta y analiza todas los documentos registrados en el sistema.',
				color: '#f1f3fe',
				icon: MenuIcons.Menu5
			}
		});

		const _params = queryString.parse(this.props.location.search);
    	this.props.history.replace(this.props.location.pathname);

    	if (_params?.document_type_id) {
    		this.setState({
				form: {
					...this.state.form,
					document_type_id: _params?.document_type_id || ''
				}
			});
    	}

		this.load();
		
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) {
			this.loadClients();
		}

		if (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
			let header = [...this.state.header];
			header.shift();
			this.setState({
				header
			});
		}
	}

	loadClients = async () => {
		const res: any = await ReportService.admin.getClients({
			withoutLoading: true
		});
		this.setState({
			clients: res.clients || []
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.admin.documents.getVerifications({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.verifications.rows,
			last_page: res.verifications.count,
			approved_count: res.approved_count || 0,
			rejected_count: res.rejected_count || 0,
			verifications_count: res.verifications_count || 0,
			cases: res.cases || [],
			categories_count: res.categories_count || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_FORM,
			page: 1
		},() => this.load(true));
	}

	getColor = (item: any) => {
		let color = '';

		if (item?.result) {
			return {
				color: '#4eb686',
				secondary_color: '#eafbf3',
				icon: SuccessIcon
			}
		}
		else {
			return {
				color: '#e73a4c',
				secondary_color: '#feeff1',
				icon: CloseRedIcon
			}
		}

		return color;
	}

	view = (item: any) => {
		window.open(window.location.href + '/view/' + Hash.encryptWithAES(item?.id),'_blank');
	}

	render() {
		return (
			<div id="documents-report">
				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-12 row">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por nombre, correo o cédula"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md">
									<Select
										color="white"
										placeholder="Seleccionar"
										label="Origen"
										name="origin"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.origin }
										options={ [
											{ value: Constants.ORIGINS.ANDROID.toString(), label: 'Android' },
											{ value: Constants.ORIGINS.IOS.toString(), label: 'iOS' },
											{ value: Constants.ORIGINS.WEB.toString(), label: 'Web' }
										] } />
								</div>
								{
									this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
										<div className="col-md">
											<Select
												color="white"
												placeholder="Seleccionar"
												label="Cliente"
												name="client_id"
												onChange={ (e: any) => this.change(e,async () => {
													this.load(true);
												}) }
												value={ this.state.form.client_id }
												options={ this.state.clients.map((item: any) => {
													return {
														value: item.id,
														label: item?.name + ' ' + item?.lastname
													}
												}) } />
										</div>
									)
								}
								<div className="col-md">
									<Select
										color="white"
										placeholder="Seleccionar"
										label="Tipo de Documento"
										name="document_type_id"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.document_type_id }
										options={ [
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.ID.toString(), label: 'Cédula de Identidad' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.PASSPORT.toString(), label: 'Pasaporte' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.RIF.toString(), label: 'RIF' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_NIT.toString(), label: 'NIT Colombiano' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.DRIVER_LICENSE.toString(), label: 'Licencia de Conducir' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD.toString(), label: 'Certificado Registro de Vehículos' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.MEDICAL_CERTIFICATE.toString(), label: 'Certificado Médico de Conducir' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.RACDA.toString(), label: 'RACDA' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.ROCT.toString(), label: 'ROCT' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.INSOPESCA.toString(), label: 'INSOPESCA' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.RCV.toString(), label: 'Poliza de Seguro' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_PERMIT.toString(), label: 'Permiso Sanitario' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.RESQUIMC.toString(), label: 'RESQUIMC' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_CERTIFICATE.toString(), label: 'Certificado de Salud' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.FOOD_HANDLING.toString(), label: 'Certificado de Manipulación de Alimentos' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.VOUCHER.toString(), label: 'Voucher' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.VOUCHER_WITHOUT_DATA.toString(), label: 'Voucher (Sin datos)' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.CASH.toString(), label: 'Efectivo' },
											{ value: Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_VOUCHER.toString(), label: 'Voucher Colombiano' },
										] } />
								</div>
								<div className="col-md">
									<Select
										color="white"
										placeholder="Seleccionar"
										label="Categoría"
										name="category"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.category }
										options={ [
											{ value: 'A', label: 'Categoría A' },
											{ value: 'B', label: 'Categoría B' },
											{ value: 'C', label: 'Categoría C' },
											{ value: 'D', label: 'Categoría D' },
											{ value: 'E', label: 'Categoría E' },
										] } />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6 row">
								<div className="col-md-6">
									<div className="container-inline">
										<p className="label-inline">Estado</p>
										<div className="select-inline">
											<Select
												color="white"
												placeholder="Seleccionar"
												name="status"
												onChange={ (e: any) => this.change(e,() => this.load(true)) }
												value={ this.state.form.status }
												options={ [
													{ value: Constants.IDENTITY_VERIFICATION_RESULT.YES.toString(), label: 'Verificados' },
													{ value: Constants.IDENTITY_VERIFICATION_RESULT.NO.toString(), label: 'Rechazados' },
												] } />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="container-inline">
										<p className="label-inline">Filtrar por motivo</p>
										<div className="select-inline">
											<Select
												color="white"
												placeholder="Seleccionar"
												name="case"
												onChange={ (e: any) => this.change(e,() => this.load(true)) }
												value={ this.state.form.case }
												options={ this.state.cases.map((item: any) => {
													return {
														value: item.id,
														label: item.name
													}
												}) } />
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 text-right">
								{
									this.state.form != INITIAL_FORM && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<div className="container-totals">
					<div className="row">
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<img src={ MenuIcons.Menu5 } className="blue" />
								</div>
								<div>
									<p className="value-top">Total registros</p>
									<p className="value-bottom">{ this.state.verifications_count }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#ecf9f3' }}>
									<img src={ LikeIcon } className="green" />
								</div>
								<div>
									<p className="value-top">Verificados</p>
									<p className="value-bottom">{ this.state.approved_count }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#feeeef' }}>
									<img src={ DislikeIcon } className="red" />
								</div>
								<div>
									<p className="value-top">Rechazados</p>
									<p className="value-bottom">{ this.state.rejected_count }</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/*<div className="container-totals">
					<div className="row">
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<p>A</p>
								</div>
								<div>
									<p className="value-bottom">{ this.state.categories_count[0] || 0 }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<p>B</p>
								</div>
								<div>
									<p className="value-bottom">{ this.state.categories_count[1] || 0 }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<p>C</p>
								</div>
								<div>
									<p className="value-bottom">{ this.state.categories_count[2] || 0 }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<p>D</p>
								</div>
								<div>
									<p className="value-bottom">{ this.state.categories_count[3] || 0 }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<p>E</p>
								</div>
								<div>
									<p className="value-bottom">{ this.state.categories_count[4] || 0 }</p>
								</div>
							</div>
						</div>
					</div>
				</div>*/}

				<Table title="Reporte de Documentos" data={ this.state.data.length } header={ this.state.header } withoutTbody={ true }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tbody key={index} className="row-group" onClick={() => this.view(i)}>
								<tr>
									{
										this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
											<td rowSpan={ i.verifications?.length + 1 }>
												{ i.user != null && (
													<div className="container-initial">
														<p className="initial">{ (i?.user?.name + ' ' + i?.user?.lastname).substr(0,1) }</p>
														<p>{ i?.user?.name + ' ' + i?.user?.lastname }</p>
													</div>
												) }	
											</td>
										)
									}
									<td rowSpan={ i.verifications?.length + 1 }>
										{
											i.name && (
												<p className="name">{ (i.name || '') + ' ' + (i.lastname || '') }</p>
											)
										}
										<p className="email">{ i.email }</p>
										{
											i.document && (
												<p className="name">{ i.document }</p>
											)
										}
									</td>
								</tr>
								{
									i.verifications?.map((item: any) => {
										const color: any = this.getColor(item);
										return (
											<tr>
												<td>
													{
														(item.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VOUCHER || item.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_VOUCHER) ? (
															<p className="category-container">{ item?.document_type?.name ? (item?.document_type?.name + ` (${ item?.document_category })`) :  '-' }</p>
														) : (
															<p className="category-container">{ item?.document_type?.name_with_category || '-' }</p>
														)
													}
												</td>
												<td>
													<div className="container-origin">
														{
															i.verification != null && (
																<img src={ Constants.BASE_PUBLIC + item?.origin?.icon } />
															)
														}
														<p>{ item?.origin?.name || '-' }</p>
													</div>
												</td>
												<td>{ moment(item?.created_at).isValid() ? moment(item.created_at).format('DD/MM/YYYY HH:mm') : '-' }</td>
												<td>{ item.attempts_count || 0 }</td>
												<td>
													<div style={{
														color: color?.color,
														backgroundColor: color?.secondary_color
													}} className="result-container">
														<img src={ color?.icon } />
														{ item?.result_text || '-' }
													</div>
												</td>
												<td className="container-tags">
													{
														item?.cases?.map((item: any) => {
															return (
																<div className="tag">
																	<p>{ item.case?.name }</p>
																</div>
															)
														})
													}
												</td>
											</tr>
										)
									})
								}
							</tbody>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(DocumentReport);